'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserActivationController = function () {
    function UserActivationController($state, $stateParams, $ionicLoading, ApiAuthentication) {
        _classCallCheck(this, UserActivationController);

        this.token = $stateParams.token;
        this.$ionicLoading = $ionicLoading;
        this.ApiAuthentication = ApiAuthentication;
        this.loading = [];
        this.activationSuccess = false;
    }

    _createClass(UserActivationController, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.showLoading();
            this.ApiAuthentication.activateUser(this.token).then(function (response) {
                if (undefined !== response) {
                    _this.activationSuccess = true;
                }
                _this.hideLoading();
            });
        }
    }, {
        key: 'showLoading',
        value: function showLoading() {
            this.loading.push(1);
            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });
        }
    }, {
        key: 'hideLoading',
        value: function hideLoading() {
            this.loading.pop();
            if (this.loading.length === 0) {
                this.$ionicLoading.hide();
            }
        }
    }]);

    return UserActivationController;
}();

exports.default = UserActivationController;


/** WEBPACK FOOTER **
 ** ./src/app/components/extras/userActivation.controller.js
 **/